<div [ngClass]="{ 'snack-bar-with-action': properties.action }">
  <p class="message-text" [innerHTML]="properties.messageText"></p>
  <ng-template cdkPortalOutlet></ng-template>
</div>

@if (properties.subMessageText) {
  <p class="message-sub-text">{{ properties.subMessageText }}</p>
}
<mat-icon class="snack-close-btn" (click)="closeSnack()">close</mat-icon>
